import { render, staticRenderFns } from "./QuotazionePage.vue?vue&type=template&id=7694a136"
import script from "./QuotazionePage.vue?vue&type=script&lang=js"
export * from "./QuotazionePage.vue?vue&type=script&lang=js"
import style0 from "./QuotazionePage.vue?vue&type=style&index=0&id=7694a136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports